import {Component, inject} from '@angular/core';
import {
  NbButtonModule,
  NbCardModule,
  NbDatepickerModule,
  NbDialogRef,
  NbIconModule,
  NbInputModule,
  NbLayoutModule,
  NbOptionModule,
  NbRadioModule,
  NbSelectModule,
  NbToastrService
} from "@nebular/theme";
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {notificationsParams} from "../../../../../shared/settings";
import {MatchesService} from "../../../../../services/matches.service";
import {FormDatetimeComponent} from "../../../../../shared/components/forms/form-datetime/form-datetime.component";
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {
  FormDatetimeMultipartsComponent
} from "../../../../../shared/components/forms/form-datetime-multiparts/form-datetime-multiparts.component";

@Component({
  selector: 'app-propose-new-date-form',
  standalone: true,
  imports: [
    TranslateModule,
    NbButtonModule,
    NbCardModule,
    NbIconModule,
    ReactiveFormsModule,
    NbOptionModule,
    NbSelectModule,
    NbDatepickerModule,
    NbRadioModule,
    ReactiveFormsModule,
    NbLayoutModule,
    NbInputModule,
    FormDatetimeComponent,
    FormDatetimeMultipartsComponent
  ],
  templateUrl: './propose-new-date-form.component.html',
  styleUrl: './propose-new-date-form.component.scss'
})
export class ProposeNewDateFormComponent {
  private readonly translate = inject(TranslateService);
  proposeNewDateForm!: FormGroup;
  match!: any;

  minDate = new Date();
  maxDate = new Date(new Date().getFullYear() + 1, 11, 31);

  constructor(private fb: FormBuilder,
              private matchesService: MatchesService, private toastrService: NbToastrService, protected dialogRef: NbDialogRef<any>) {}

  ngOnInit(): void {
    this.proposeNewDateForm = this.fb.group({
      match_id: [this.match.match_id, [Validators.required]],
      scheduled_start_time: [new Date(this.match.scheduled_start_time), [Validators.required]]
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  submit() {
    if (this.proposeNewDateForm.valid) {
      const formValue = this.proposeNewDateForm.value;

      // Extraire l'heure et les minutes du champ time (format HH:mm)
      const [hours, minutes] = formValue.scheduled_start_time.toTimeString().split(':').map(Number);

      // Créer scheduled_start_time en combinant date et time
      const scheduled_start_time = new Date(formValue.scheduled_start_time);
      scheduled_start_time.setHours(hours, minutes, 0, 0);

      const requestData = {
        ...formValue,
        scheduled_start_time: scheduled_start_time.toISOString(),
      };

      this.matchesService.proposeNewTime(this.match.match_id, requestData).subscribe((response: any) => {
        this.toastrService.success(this.translate.instant('games.match.new_date_submitted'), this.translate.instant('common.information'), notificationsParams);
        this.dialogRef.close();
      });
    }
  }

  getControl(controlName: string): FormControl {
    return this.proposeNewDateForm.get(controlName) as FormControl;
  }
}
